import Immutable from 'seamless-immutable';
import IntegrationCredentialsModel from './integration-credentials-model';

/**
 * Transforms an array of backend credentials objects into an IntegrationCredentialsCollection
 * @param {Object[]} credentials - backend formatted credentials
 * @returns {Credentials[]}
 */
function deserialize(crendentials = []) {
  return Immutable(_.map(crendentials, IntegrationCredentialsModel.deserialize));
}

/**
 * Transforms an IntegrationCredentialsCollection into an array of backend integration objects
 * @param {Credentials[]} integrations
 * @returns {Object[]}
 */
function serialize(crendentials) {
  return _.map(crendentials, (crendential) => IntegrationCredentialsModel.serialize(crendential));
}

export default {
  create: deserialize,
  deserialize,
  serialize,
};
